import { useQuery } from 'react-query';
import attendance from 'api/attendance';

type AttendanceDefaults = {
  baseDays: string;
  baseHours: string;
  isLoading: boolean;
};

export function useAttendanceDefaults(payrollMonth: string): AttendanceDefaults {
  const {data, isFetching} = useQuery({
    queryKey: ['attendance-working-days', payrollMonth],
    queryFn: () => attendance.getWorkingDays(payrollMonth),
    enabled: Boolean(payrollMonth),
  });

  return {
    baseDays: String(data?.data.baseDays ?? 0),
    baseHours: String(data?.data.baseHours ?? 0),
    isLoading: isFetching,
  };
}
